module.exports = __webpack_public_path__ + "assets/img/Spin-Bowling-Academy.ceff8796.png";